// Customer growth + retention (approved HTML component: customer-retention-growth).
import type { ReactNode } from 'react';
import type { HealthStat } from '../mockData.js';
import { HealthGrid } from './HealthGrid.js';

export interface CustomerRetentionGrowthProps {
  stats: HealthStat[];
}

export function CustomerRetentionGrowth({ stats }: CustomerRetentionGrowthProps): ReactNode {
  return (
    <HealthGrid
      title="Customer growth & retention"
      subtitle="Selected period vs comparable prior period"
      stats={stats}
      dataComponent="customer-retention-growth"
    />
  );
}
